import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import { ICampaignAlterationRequestPayload } from "../types";

export function useCreateAlterationRequest(briefId?: string, onSuccessCallback?: () => void) {
  const {
    mutate: createAlteration,
    isLoading: isCreating,
    isSuccess: isCreated,
    error,
  } = useMutation({
    mutationFn: (payload: ICampaignAlterationRequestPayload) =>
      CampaignService.createAlterationRequest(payload).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg || "Failed to create alteration request");
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      ToastService.success("Alteration request created successfully");
      onSuccessCallback?.();
    },
  });

  return {
    createAlteration,
    isCreating,
    isCreated,
    error,
  };
}
